import React from 'react'

import influencerData from '../../data-influencer/daniel-aminati'
import PageBuilder from '../PageBuilder'
import PageLayout from './PageLayout'

const DanielAminati = () => (
    <PageBuilder influencerData={influencerData}>
        <PageLayout />
    </PageBuilder>
)

export default DanielAminati
